import Button, {BtnColor} from "../../../components/Button/Button";
import {Link} from "react-router-dom";
import React, {useEffect, useRef, useState} from "react";
import { HexColorPicker } from "react-colorful";
import { IoAddCircleOutline } from "react-icons/io5";

import '../styles.scss'
import classNames from "classnames";
import {useDispatch, useSelector} from "react-redux";
import {onAppSetSplash} from "../../../store/App/actions";
import EmulatorSplashScreen from "../../../components/EmulatorSplashScreen/EmulatorSplashScreen";
import OutsideClickHandler from "react-outside-click-handler";
import {useTranslation} from "react-i18next";

const Step2 = () => {
    const { t } = useTranslation()
    const dispatch = useDispatch();
    const photoRef = useRef(null);

    const [tab, setTab] = useState(0)
    const [showBackgroundPicker, setShowBackgroundPicker] = useState(false)
    const [showContentPicker, setShowContentPicker] = useState(false)

    const { header, body, backgroundImage, headerFont, bodyFont, backgroundColor, textColor} = useSelector(({ app: { splash }}) => splash)

    const onChangeHeader = (e) => dispatch(onAppSetSplash('header', e.target.value))
    const onChangeBody = (e) => dispatch(onAppSetSplash('body', e.target.value))
    const onChangeBackgroundImage = (file) => dispatch(onAppSetSplash('backgroundImage', file))
    const onChangeHeaderFont = (e) => dispatch(onAppSetSplash('headerFont', e.target.value))
    const onChangeBodyFont = (e) => dispatch(onAppSetSplash('bodyFont', e.target.value))
    const onChangeBackgroundColor = (color) => dispatch(onAppSetSplash('backgroundColor', color))
    const onChangeTextColor = (color) => dispatch(onAppSetSplash('textColor', color))

    const onClickAddPhoto = () => photoRef.current.click();

    const onChangePhoto = (e) => {
        let reader = new FileReader();
        let file = e.target.files[0];

        reader.onloadend = () => {
            onChangeBackgroundImage(reader.result)
        }

        reader.readAsDataURL(file)
    }

    return (
        <div className="mx-12 mt-5">
            <div className="flex justify-between items-end">
                <div className="text-2xl font-bold w-1/3">2. {t('Landing page')}</div>
                <div className="w-52 mb-2 w-1/3">
                    <div className="text-center">{t('Step')} 2 of 4</div>
                    <div className="">
                        <div className="h-3 relative max-w-xl rounded-full overflow-hidden">
                            <div className="w-full h-full bg-gray-200 absolute" />
                            <div className="h-full bg-indigo-600 absolute" style={{width:'50%'}} />
                        </div>
                    </div>
                </div>
                <div className="flex w-1/3 justify-end">
                    <Link to={'/chain/app?step=1'}>
                        <Button color={BtnColor.gray} className="ml-2 px-10">{t('Back')}</Button>
                    </Link>
                    <Link to={'/chain/app?step=3'}>
                        <Button color={BtnColor.gray} className="ml-2 px-10">{t('Next')}</Button>
                    </Link>
                </div>
            </div>
            <div className="w-1/2 mt-5">
                <div>{t('Customise your landing page with your brand logo and message.')}</div>

                <div className="flex mt-5">
                    <Button color={tab === 0 ? BtnColor.indigo : BtnColor.gray} className="rounded-r-none" onClick={() =>setTab(0)}>
                        {t('Text')}
                    </Button>
                    <Button color={tab === 1 ? BtnColor.indigo : BtnColor.gray} className="rounded-r-none rounded-l-none" onClick={() =>setTab(1)}>
                        {t('Fonts')}
                    </Button>
                    <Button color={tab === 2 ? BtnColor.indigo : BtnColor.gray} className="rounded-l-none" onClick={() =>setTab(2)}>
                        {t('Colors')}
                    </Button>
                </div>
            </div>
            <div>
                <div className="mt-8 w-full flex" >
                    {tab === 0 ? (
                        <div className="grid grid-cols-1 gap-6 w-1/2 mr-10">
                            <label className="block">
                                <span className="text-gray-700">{t('Header text')}</span>
                                <input type="text"
                                       className="mt-1 block w-full rounded-md bg-blue-100 border-transparent focus:border-gray-500 focus:bg-white focus:ring-0"
                                       placeholder=""
                                       value={header}
                                       onChange={onChangeHeader}
                                />
                            </label>
                            <label className="block">
                                <span className="text-gray-700">{t('Body text')}</span>
                                <textarea
                                    className="mt-1 block w-full rounded-md bg-blue-100 border-transparent focus:border-gray-500 focus:bg-white focus:ring-0"
                                    rows="3"
                                    value={body}
                                    onChange={onChangeBody}
                                />
                            </label>

                            <div className="block">
                                <span className="text-gray-700">{t('Logo / Image')}</span>
                                <div className="py-5  text-center w-60">
                                    <div className="mb-4 flex bg-blue-100 items-center justify-center file-input"
                                         onClick={onClickAddPhoto}
                                         style={{width: '200px', height: '200px', backgroundSize: 'cover', backgroundRepeat: 'no-repeat', backgroundPosition: 'center center', backgroundImage: `url(${backgroundImage})`}}>

                                        <input type="file"
                                               className="hidden"
                                               ref={photoRef}
                                               onChange={onChangePhoto} />

                                        {!backgroundImage ?(
                                            <div className="flex flex-col">
                                                <div className="items-center">{t('Background image')}</div>
                                                <div className="sub items-center">1024 x 1024 px</div>
                                                <div className="sub m-auto mt-5">
                                                    <IoAddCircleOutline size={30} />
                                                </div>
                                            </div>
                                        ):null}
                                    </div>
                                </div>
                            </div>
                        </div>
                    ) :null}

                    {tab === 1?(
                        <div className=" w-1/2 mr-10">
                            <label className="block">
                                <span className="text-gray-700">{t('Header 1')}</span>
                                <select
                                    className="block w-64 mt-1 rounded-md bg-blue-100 border-transparent focus:border-gray-500 focus:bg-white focus:ring-0"
                                    value={headerFont}
                                    onChange={onChangeHeaderFont}
                                >
                                    <option value=""></option>
                                    <option value="font-sans">Open Sans</option>
                                    <option value="font-mono">Monospace</option>
                                    <option value="font-serif">Font Serif</option>
                                </select>
                            </label>
                            <label className="block mt-10">
                                <span className="text-gray-700">{t('Body 1')}</span>
                                <select
                                    className="block w-64 mt-1 rounded-md bg-blue-100 border-transparent focus:border-gray-500 focus:bg-white focus:ring-0"
                                    value={bodyFont}
                                    onChange={onChangeBodyFont}
                                >
                                    <option value=""></option>
                                    <option value="font-sans">Open Sans</option>
                                    <option value="font-mono">Monospace</option>
                                    <option value="font-serif">Font Serif</option>
                                </select>
                            </label>
                        </div>
                    ):null}

                    {tab === 2?(
                        <div className="w-1/2 flex mr-10">
                            <label className="block">
                                <span className="text-gray-700">{t('Background')}</span>
                                <div className="bg-white rounded shadow"
                                     style={{width:50, height:50, backgroundColor: `${backgroundColor}`}}
                                     onClick={() => setShowBackgroundPicker(prevState => !prevState)}
                                />

                                <input type="text"
                                       value={backgroundColor}
                                       autoComplete="off"
                                       onChange={(e) => onChangeBackgroundColor(e.target.value)}
                                       className="mt-1 focus:ring-indigo-500 focus:border-indigo-500 block w-32  shadow-sm sm:text-sm border-gray-300 rounded-md" />
                                {showBackgroundPicker ? (
                                    <OutsideClickHandler onOutsideClick={() => setShowBackgroundPicker(false)} >
                                        <div className="absolute z-10">
                                            <HexColorPicker color={backgroundColor} onChange={onChangeBackgroundColor} />
                                        </div>
                                    </OutsideClickHandler>
                                ) :null}
                            </label>
                            <label className="block ml-10">
                                <span className="text-gray-700">{t('Body text')}</span>
                                <div className="bg-white rounded shadow"
                                     style={{width:50, height:50, backgroundColor: `${textColor}`}}
                                     onClick={() => setShowContentPicker(prevState => !prevState)}
                                />

                                <input type="text"
                                       value={textColor}
                                       autoComplete="off"
                                       onChange={(e) => onChangeTextColor(e.target.value)}
                                       className="mt-1 focus:ring-indigo-500 focus:border-indigo-500 block w-32  shadow-sm sm:text-sm border-gray-300 rounded-md" />
                                {showContentPicker ? (
                                    <OutsideClickHandler onOutsideClick={() => setShowContentPicker(false)} >
                                        <div className="absolute z-10">
                                            <HexColorPicker color={textColor} onChange={onChangeTextColor} />
                                        </div>
                                    </OutsideClickHandler>
                                ) :null}
                            </label>

                        </div>
                    ):null}

                    <div className="w-1/2 bg-gray-100 flex justify-center p-5">
                        <EmulatorSplashScreen header={header}
                                              body={body}
                                              backgroundImage={backgroundImage}
                                              headerFont={headerFont}
                                              bodyFont={bodyFont}
                                              backgroundColor={backgroundColor}
                                              textColor={textColor} />
                    </div>
                </div>

            </div>
        </div>
    )
}

export default Step2
